/*
 * Small presentational helpers for the downloads page — kept pure + separate so
 * they're unit-testable and the views stay declarative.
 */

/**
 * Expand a compact size string ("296 MB", "3.4 GB") into a spoken form for
 * accessible names ("296 megabytes", "3.4 gigabytes"). Leaves the visible chip
 * text compact; only the aria-label reads the long form.
 */
export const spokenSize = (size) => {
  if (!size) return "";
  return size
    .replace(/\bGB\b/g, "gigabytes")
    .replace(/\bMB\b/g, "megabytes")
    .replace(/\bKB\b/g, "kilobytes")
    .replace(/\bTB\b/g, "terabytes");
};

/**
 * Format an ISO token-expiry into "Oct 19" (UTC, so a date at 00:00Z doesn't
 * roll back a day in a western timezone). Rendered as "Available until Oct 19".
 */
export const formatExpiry = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat("en-US", {
    timeZone: "UTC",
    month: "short",
    day: "numeric",
  }).format(d);
};

/** Mask an email for the re-mint success line: "b•••@example.com". */
export const maskEmail = (email) => {
  const val = (email || "").trim();
  const at = val.indexOf("@");
  // Mask whenever there's at least one character before the "@" (a valid email
  // always has one), so even a single-char local part isn't shown in full.
  return at >= 1 ? `${val[0]}•••${val.slice(at)}` : val;
};

/** Lightweight email shape check for the inline (non-native) form validation. */
export const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || "").trim());

/** Zero-pad a part number to two digits for the badge ("01", "12"). */
export const padPart = (n) => String(n).padStart(2, "0");
